module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/chevron-prev-67182ebabc20700b5a4e3b05adb5c917.png";